import * as i0 from '@angular/core';
import * as i1 from './module';
import * as i2 from '@angular/common';
import * as i3 from '@angular/forms';
import * as i4 from './components/action-sheet/action-sheet-component';
import * as i5 from './components/alert/alert-component';
import * as i6 from './components/app/click-block';
import * as i7 from './components/app/app-root';
import * as i8 from './components/app/overlay-portal';
import * as i9 from './components/avatar/avatar';
import * as i10 from './components/backdrop/backdrop';
import * as i11 from './components/badge/badge';
import * as i12 from './components/button/button';
import * as i13 from './components/card/card';
import * as i14 from './components/card/card-content';
import * as i15 from './components/card/card-header';
import * as i16 from './components/card/card-title';
import * as i17 from './components/checkbox/checkbox';
import * as i18 from './components/chip/chip';
import * as i19 from './components/grid/col';
import * as i20 from './components/content/content';
import * as i21 from './components/datetime/datetime';
import * as i22 from './components/fab/fab';
import * as i23 from './components/fab/fab-container';
import * as i24 from './components/fab/fab-list';
import * as i25 from './components/grid/grid';
import * as i26 from './components/img/img';
import * as i27 from './components/icon/icon';
import * as i28 from './components/infinite-scroll/infinite-scroll';
import * as i29 from './components/infinite-scroll/infinite-scroll-content';
import * as i30 from './components/item/item';
import * as i31 from './components/item/item-content';
import * as i32 from './components/item/item-divider';
import * as i33 from './components/item/item-group';
import * as i34 from './components/item/item-options';
import * as i35 from './components/item/item-reorder';
import * as i36 from './components/item/item-sliding';
import * as i37 from './components/label/label';
import * as i38 from './components/list/list';
import * as i39 from './components/list/list-header';
import * as i40 from './components/item/reorder';
import * as i41 from './components/loading/loading-component';
import * as i42 from './components/menu/menu';
import * as i43 from './components/menu/menu-close';
import * as i44 from './components/menu/menu-toggle';
import * as i45 from './components/modal/modal-component';
import * as i46 from './components/nav/nav';
import * as i47 from './components/nav/nav-pop';
import * as i48 from './components/nav/nav-pop-anchor';
import * as i49 from './components/nav/nav-push';
import * as i50 from './components/nav/nav-push-anchor';
import * as i51 from './components/note/note';
import * as i52 from './components/option/option';
import * as i53 from './components/picker/picker-component';
import * as i54 from './components/picker/picker-column';
import * as i55 from './components/popover/popover-component';
import * as i56 from './components/radio/radio-button';
import * as i57 from './components/radio/radio-group';
import * as i58 from './components/range/range';
import * as i59 from './components/range/range-knob';
import * as i60 from './components/refresher/refresher';
import * as i61 from './components/refresher/refresher-content';
import * as i62 from './components/grid/row';
import * as i63 from './components/scroll/scroll';
import * as i64 from './components/searchbar/searchbar';
import * as i65 from './components/segment/segment';
import * as i66 from './components/segment/segment-button';
import * as i67 from './components/select/select';
import * as i68 from './components/select/select-popover-component';
import * as i69 from './components/show-hide-when/show-when';
import * as i70 from './components/show-hide-when/hide-when';
import * as i71 from './components/slides/slide';
import * as i72 from './components/slides/slides';
import * as i73 from './components/spinner/spinner';
import * as i74 from './components/split-pane/split-pane';
import * as i75 from './components/tabs/tab';
import * as i76 from './components/tabs/tab-button';
import * as i77 from './components/tabs/tab-highlight';
import * as i78 from './components/tabs/tabs';
import * as i79 from './components/input/input';
import * as i80 from './components/thumbnail/thumbnail';
import * as i81 from './components/toast/toast-component';
import * as i82 from './components/toggle/toggle';
import * as i83 from './components/toolbar/toolbar-footer';
import * as i84 from './components/toolbar/toolbar-header';
import * as i85 from './components/toolbar/toolbar';
import * as i86 from './components/toolbar/toolbar-item';
import * as i87 from './components/toolbar/toolbar-title';
import * as i88 from './components/toolbar/navbar';
import * as i89 from './components/typography/typography';
import * as i90 from './components/virtual-scroll/virtual-footer';
import * as i91 from './components/virtual-scroll/virtual-header';
import * as i92 from './components/virtual-scroll/virtual-item';
import * as i93 from './components/virtual-scroll/virtual-scroll';
export const IonicModuleNgFactory:i0.NgModuleFactory<i1.IonicModule> = (null as any);
var _decl0_0:i2.NgClass = (<any>(null as any));
var _decl0_1:i2.NgComponentOutlet = (<any>(null as any));
var _decl0_2:i2.NgForOf<any> = (<any>(null as any));
var _decl0_3:i2.NgIf = (<any>(null as any));
var _decl0_4:i2.NgTemplateOutlet = (<any>(null as any));
var _decl0_5:i2.NgStyle = (<any>(null as any));
var _decl0_6:i2.NgSwitch = (<any>(null as any));
var _decl0_7:i2.NgSwitchCase = (<any>(null as any));
var _decl0_8:i2.NgSwitchDefault = (<any>(null as any));
var _decl0_9:i2.NgPlural = (<any>(null as any));
var _decl0_10:i2.NgPluralCase = (<any>(null as any));
var _decl0_11:i3.ɵbf = (<any>(null as any));
var _decl0_12:i3.NgSelectOption = (<any>(null as any));
var _decl0_13:i3.ɵq = (<any>(null as any));
var _decl0_14:i3.DefaultValueAccessor = (<any>(null as any));
var _decl0_15:i3.ɵbc = (<any>(null as any));
var _decl0_16:i3.ɵbe = (<any>(null as any));
var _decl0_17:i3.CheckboxControlValueAccessor = (<any>(null as any));
var _decl0_18:i3.SelectControlValueAccessor = (<any>(null as any));
var _decl0_19:i3.SelectMultipleControlValueAccessor = (<any>(null as any));
var _decl0_20:i3.RadioControlValueAccessor = (<any>(null as any));
var _decl0_21:i3.NgControlStatus = (<any>(null as any));
var _decl0_22:i3.NgControlStatusGroup = (<any>(null as any));
var _decl0_23:i3.RequiredValidator = (<any>(null as any));
var _decl0_24:i3.MinLengthValidator = (<any>(null as any));
var _decl0_25:i3.MaxLengthValidator = (<any>(null as any));
var _decl0_26:i3.PatternValidator = (<any>(null as any));
var _decl0_27:i3.CheckboxRequiredValidator = (<any>(null as any));
var _decl0_28:i3.EmailValidator = (<any>(null as any));
var _decl0_29:i3.NgModel = (<any>(null as any));
var _decl0_30:i3.NgModelGroup = (<any>(null as any));
var _decl0_31:i3.NgForm = (<any>(null as any));
var _decl0_32:i3.FormControlDirective = (<any>(null as any));
var _decl0_33:i3.FormGroupDirective = (<any>(null as any));
var _decl0_34:i3.FormControlName = (<any>(null as any));
var _decl0_35:i3.FormGroupName = (<any>(null as any));
var _decl0_36:i3.FormArrayName = (<any>(null as any));
var _decl0_37:i4.ActionSheetCmp = (<any>(null as any));
var _decl0_38:i5.AlertCmp = (<any>(null as any));
var _decl0_39:i6.ClickBlock = (<any>(null as any));
var _decl0_40:i7.IonicApp = (<any>(null as any));
var _decl0_41:i8.OverlayPortal = (<any>(null as any));
var _decl0_42:i9.Avatar = (<any>(null as any));
var _decl0_43:i10.Backdrop = (<any>(null as any));
var _decl0_44:i11.Badge = (<any>(null as any));
var _decl0_45:i12.Button = (<any>(null as any));
var _decl0_46:i13.Card = (<any>(null as any));
var _decl0_47:i14.CardContent = (<any>(null as any));
var _decl0_48:i15.CardHeader = (<any>(null as any));
var _decl0_49:i16.CardTitle = (<any>(null as any));
var _decl0_50:i17.Checkbox = (<any>(null as any));
var _decl0_51:i18.Chip = (<any>(null as any));
var _decl0_52:i19.Col = (<any>(null as any));
var _decl0_53:i20.Content = (<any>(null as any));
var _decl0_54:i21.DateTime = (<any>(null as any));
var _decl0_55:i22.FabButton = (<any>(null as any));
var _decl0_56:i23.FabContainer = (<any>(null as any));
var _decl0_57:i24.FabList = (<any>(null as any));
var _decl0_58:i25.Grid = (<any>(null as any));
var _decl0_59:i26.Img = (<any>(null as any));
var _decl0_60:i27.Icon = (<any>(null as any));
var _decl0_61:i28.InfiniteScroll = (<any>(null as any));
var _decl0_62:i29.InfiniteScrollContent = (<any>(null as any));
var _decl0_63:i30.Item = (<any>(null as any));
var _decl0_64:i31.ItemContent = (<any>(null as any));
var _decl0_65:i32.ItemDivider = (<any>(null as any));
var _decl0_66:i33.ItemGroup = (<any>(null as any));
var _decl0_67:i34.ItemOptions = (<any>(null as any));
var _decl0_68:i35.ItemReorder = (<any>(null as any));
var _decl0_69:i36.ItemSliding = (<any>(null as any));
var _decl0_70:i37.Label = (<any>(null as any));
var _decl0_71:i38.List = (<any>(null as any));
var _decl0_72:i39.ListHeader = (<any>(null as any));
var _decl0_73:i40.Reorder = (<any>(null as any));
var _decl0_74:i41.LoadingCmp = (<any>(null as any));
var _decl0_75:i42.Menu = (<any>(null as any));
var _decl0_76:i43.MenuClose = (<any>(null as any));
var _decl0_77:i44.MenuToggle = (<any>(null as any));
var _decl0_78:i45.ModalCmp = (<any>(null as any));
var _decl0_79:i46.Nav = (<any>(null as any));
var _decl0_80:i47.NavPop = (<any>(null as any));
var _decl0_81:i48.NavPopAnchor = (<any>(null as any));
var _decl0_82:i49.NavPush = (<any>(null as any));
var _decl0_83:i50.NavPushAnchor = (<any>(null as any));
var _decl0_84:i51.Note = (<any>(null as any));
var _decl0_85:i52.Option = (<any>(null as any));
var _decl0_86:i53.PickerCmp = (<any>(null as any));
var _decl0_87:i54.PickerColumnCmp = (<any>(null as any));
var _decl0_88:i55.PopoverCmp = (<any>(null as any));
var _decl0_89:i56.RadioButton = (<any>(null as any));
var _decl0_90:i57.RadioGroup = (<any>(null as any));
var _decl0_91:i58.Range = (<any>(null as any));
var _decl0_92:i59.RangeKnob = (<any>(null as any));
var _decl0_93:i60.Refresher = (<any>(null as any));
var _decl0_94:i61.RefresherContent = (<any>(null as any));
var _decl0_95:i62.Row = (<any>(null as any));
var _decl0_96:i63.Scroll = (<any>(null as any));
var _decl0_97:i64.Searchbar = (<any>(null as any));
var _decl0_98:i65.Segment = (<any>(null as any));
var _decl0_99:i66.SegmentButton = (<any>(null as any));
var _decl0_100:i67.Select = (<any>(null as any));
var _decl0_101:i68.SelectPopover = (<any>(null as any));
var _decl0_102:i69.ShowWhen = (<any>(null as any));
var _decl0_103:i70.HideWhen = (<any>(null as any));
var _decl0_104:i71.Slide = (<any>(null as any));
var _decl0_105:i72.Slides = (<any>(null as any));
var _decl0_106:i73.Spinner = (<any>(null as any));
var _decl0_107:i74.SplitPane = (<any>(null as any));
var _decl0_108:i75.Tab = (<any>(null as any));
var _decl0_109:i76.TabButton = (<any>(null as any));
var _decl0_110:i77.TabHighlight = (<any>(null as any));
var _decl0_111:i78.Tabs = (<any>(null as any));
var _decl0_112:i79.TextInput = (<any>(null as any));
var _decl0_113:i80.Thumbnail = (<any>(null as any));
var _decl0_114:i81.ToastCmp = (<any>(null as any));
var _decl0_115:i82.Toggle = (<any>(null as any));
var _decl0_116:i83.Footer = (<any>(null as any));
var _decl0_117:i84.Header = (<any>(null as any));
var _decl0_118:i85.Toolbar = (<any>(null as any));
var _decl0_119:i86.ToolbarItem = (<any>(null as any));
var _decl0_120:i87.ToolbarTitle = (<any>(null as any));
var _decl0_121:i88.Navbar = (<any>(null as any));
var _decl0_122:i89.Typography = (<any>(null as any));
var _decl0_123:i90.VirtualFooter = (<any>(null as any));
var _decl0_124:i91.VirtualHeader = (<any>(null as any));
var _decl0_125:i92.VirtualItem = (<any>(null as any));
var _decl0_126:i93.VirtualScroll = (<any>(null as any));
var _decl0_127:i2.AsyncPipe = (<any>(null as any));
var _decl0_128:i2.UpperCasePipe = (<any>(null as any));
var _decl0_129:i2.LowerCasePipe = (<any>(null as any));
var _decl0_130:i2.JsonPipe = (<any>(null as any));
var _decl0_131:i2.SlicePipe = (<any>(null as any));
var _decl0_132:i2.DecimalPipe = (<any>(null as any));
var _decl0_133:i2.PercentPipe = (<any>(null as any));
var _decl0_134:i2.TitleCasePipe = (<any>(null as any));
var _decl0_135:i2.CurrencyPipe = (<any>(null as any));
var _decl0_136:i2.DatePipe = (<any>(null as any));
var _decl0_137:i2.I18nPluralPipe = (<any>(null as any));
var _decl0_138:i2.I18nSelectPipe = (<any>(null as any));
var _decl0_142:i2.CommonModule = (<any>(null as any));
var _decl0_143:i3.FormsModule = (<any>(null as any));
var _decl0_144:i3.ReactiveFormsModule = (<any>(null as any));
var _decl0_145:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_146:i0.ElementRef = (<any>(null as any));
function _View_ActionSheetCmp_Host_1_0():void {
  var _any:any = (null as any);
}
function _View_ActionSheetCmp_1_0():void {
  var _any:any = (null as any);
  const currVal_0:any = !_decl0_37.d.enableBackdropDismiss;
  currVal_0;
  const currVal_1:any = _decl0_37.d.title;
  currVal_1;
  const currVal_2:any = _decl0_37.d.subTitle;
  currVal_2;
  const currVal_3:any = _decl0_37.d.buttons;
  currVal_3;
  const currVal_4:any = _decl0_37.cancelButton;
  currVal_4;
  const pd_5:any = ((<any>_decl0_37.bdClick()) !== false);
}
function _View_AlertCmp_Host_2_0():void {
  var _any:any = (null as any);
}
function _View_AlertCmp_2_0():void {
  var _any:any = (null as any);
  const currVal_0:any = !_decl0_38.d.enableBackdropDismiss;
  currVal_0;
  const currVal_1:any = _decl0_38.d.title;
  currVal_1;
  const currVal_2:any = _decl0_38.d.subTitle;
  currVal_2;
  const currVal_3:any = i0.ɵinlineInterpolate(1,'',_decl0_38.msgId,'');
  currVal_3;
  const currVal_4:any = _decl0_38.d.message;
  currVal_4;
  const currVal_5:any = _decl0_38.d.inputs.length;
  currVal_5;
  const currVal_6:any = 'alert-button-group';
  currVal_6;
  const currVal_7:any = (<any>{'alert-button-group-vertical':(_decl0_38.d.buttons.length > 2)});
  currVal_7;
  const currVal_8:any = _decl0_38.d.buttons;
  currVal_8;
  const pd_9:any = ((<any>_decl0_38.bdClick()) !== false);
}
function _View_IonicApp_Host_3_0():void {
  var _any:any = (null as any);
}
function _View_IonicApp_3_0():void {
  var _any:any = (null as any);
  const currVal_0:any = '';
  currVal_0;
  const currVal_1:any = '';
  currVal_1;
  const currVal_2:any = '';
  currVal_2;
  const currVal_3:any = 10000;
  currVal_3;
}
function _View_Button_Host_4_0():void {
  var _any:any = (null as any);
}
function _View_Button_4_0():void {
  var _any:any = (null as any);
}
function _View_Checkbox_Host_5_0():void {
  var _any:any = (null as any);
}
function _View_Checkbox_5_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_50._value;
  currVal_0;
  const currVal_1:any = _decl0_50.id;
  currVal_1;
  const currVal_2:any = _decl0_50._value;
  currVal_2;
  const currVal_3:any = _decl0_50._labelId;
  currVal_3;
  const currVal_4:any = _decl0_50._disabled;
  currVal_4;
}
function _View_Content_Host_6_0():void {
  var _any:any = (null as any);
}
function _View_Content_6_0():void {
  var _any:any = (null as any);
}
function _View_DateTime_Host_7_0():void {
  var _any:any = (null as any);
}
function _View_DateTime_7_0():void {
  var _any:any = (null as any);
  const currVal_0:any = !_decl0_54._text;
  currVal_0;
  const currVal_1:any = _decl0_54._text;
  currVal_1;
  const currVal_2:any = _decl0_54.id;
  currVal_2;
  const currVal_3:any = _decl0_54._labelId;
  currVal_3;
  const currVal_4:any = _decl0_54._disabled;
  currVal_4;
}
function _View_FabButton_Host_8_0():void {
  var _any:any = (null as any);
}
function _View_FabButton_8_0():void {
  var _any:any = (null as any);
  const currVal_0:any = 'close';
  currVal_0;
}
function _View_FabContainer_Host_9_0():void {
  var _any:any = (null as any);
}
function _View_FabContainer_9_0():void {
  var _any:any = (null as any);
}
function _View_Img_Host_10_0():void {
  var _any:any = (null as any);
}
function _View_Img_10_0():void {
  var _any:any = (null as any);
}
function _View_InfiniteScrollContent_Host_11_0():void {
  var _any:any = (null as any);
}
function _View_InfiniteScrollContent_11_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_62.loadingSpinner;
  currVal_0;
  const currVal_1:any = _decl0_62.loadingText;
  currVal_1;
}
function _View_Item_Host_12_0():void {
  var _any:any = (null as any);
}
function _View_Item_12_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_63._viewLabel;
  currVal_0;
  const currVal_1:any = _decl0_63._hasReorder;
  currVal_1;
}
function _View_ItemSliding_Host_13_0():void {
  var _any:any = (null as any);
}
function _View_ItemSliding_13_0():void {
  var _any:any = (null as any);
}
function _View_Reorder_Host_14_0():void {
  var _any:any = (null as any);
}
function _View_Reorder_14_0():void {
  var _any:any = (null as any);
  const currVal_0:any = 'reorder';
  currVal_0;
}
function _View_LoadingCmp_Host_15_0():void {
  var _any:any = (null as any);
}
function _View_LoadingCmp_15_0():void {
  var _any:any = (null as any);
  const currVal_0:any = !_decl0_74.d.showBackdrop;
  currVal_0;
  const currVal_1:any = !_decl0_74.d.enableBackdropDismiss;
  currVal_1;
  const currVal_2:any = _decl0_74.showSpinner;
  currVal_2;
  const currVal_3:any = _decl0_74.d.content;
  currVal_3;
  const pd_4:any = ((<any>_decl0_74.bdClick()) !== false);
}
function _View_Menu_Host_16_0():void {
  var _any:any = (null as any);
}
function _View_Menu_16_0():void {
  var _any:any = (null as any);
}
function _View_ModalCmp_Host_17_0():void {
  var _any:any = (null as any);
}
function _View_ModalCmp_17_0():void {
  var _any:any = (null as any);
  const currVal_0:any = !_decl0_78._bdDismiss;
  currVal_0;
  const pd_1:any = ((<any>_decl0_78._bdClick()) !== false);
}
function _View_Nav_Host_18_0():void {
  var _any:any = (null as any);
}
function _View_Nav_18_0():void {
  var _any:any = (null as any);
}
function _View_PickerCmp_Host_19_0():void {
  var _any:any = (null as any);
}
function _View_PickerCmp_19_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_86.d.buttons;
  currVal_0;
  const currVal_1:any = _decl0_86.d.columns;
  currVal_1;
  const pd_2:any = ((<any>_decl0_86.bdClick()) !== false);
}
function _View_PickerColumnCmp_Host_20_0():void {
  var _any:any = (null as any);
}
function _View_PickerColumnCmp_20_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_87.col.prefix;
  currVal_0;
  const currVal_1:any = _decl0_87.col.optionsWidth;
  currVal_1;
  const currVal_2:any = _decl0_87.col.options;
  currVal_2;
  const currVal_3:any = _decl0_87.col.suffix;
  currVal_3;
}
function _View_PopoverCmp_Host_21_0():void {
  var _any:any = (null as any);
}
function _View_PopoverCmp_21_0():void {
  var _any:any = (null as any);
  const currVal_0:any = !_decl0_88.d.showBackdrop;
  currVal_0;
  const pd_1:any = ((<any>_decl0_88._bdClick()) !== false);
}
function _View_RadioButton_Host_22_0():void {
  var _any:any = (null as any);
}
function _View_RadioButton_22_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_89._checked;
  currVal_0;
  const currVal_1:any = _decl0_89.id;
  currVal_1;
  const currVal_2:any = _decl0_89._checked;
  currVal_2;
  const currVal_3:any = _decl0_89._labelId;
  currVal_3;
  const currVal_4:any = _decl0_89._disabled;
  currVal_4;
}
function _View_Range_Host_23_0():void {
  var _any:any = (null as any);
}
function _View_Range_23_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_91._ticks;
  currVal_0;
  const currVal_1:any = _decl0_91._barL;
  currVal_1;
  const currVal_2:any = _decl0_91._barR;
  currVal_2;
  const currVal_3:any = _decl0_91._ratioA;
  currVal_3;
  const currVal_4:any = _decl0_91._pressedA;
  currVal_4;
  const currVal_5:any = _decl0_91._pin;
  currVal_5;
  const currVal_6:any = _decl0_91._min;
  currVal_6;
  const currVal_7:any = _decl0_91._max;
  currVal_7;
  const currVal_8:any = _decl0_91._valA;
  currVal_8;
  const currVal_9:any = _decl0_91._disabled;
  currVal_9;
  const currVal_10:any = _decl0_91._labelId;
  currVal_10;
  const currVal_11:any = _decl0_91._dual;
  currVal_11;
  const pd_12:any = ((<any>_decl0_91._keyChg(true,false)) !== false);
  const pd_13:any = ((<any>_decl0_91._keyChg(false,false)) !== false);
}
function _View_RangeKnob_Host_24_0():void {
  var _any:any = (null as any);
}
function _View_RangeKnob_24_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_92.pin;
  currVal_0;
}
function _View_RefresherContent_Host_25_0():void {
  var _any:any = (null as any);
}
function _View_RefresherContent_25_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_94.pullingIcon;
  currVal_0;
  const currVal_1:any = _decl0_94.pullingText;
  currVal_1;
  const currVal_2:any = _decl0_94.refreshingSpinner;
  currVal_2;
  const currVal_3:any = _decl0_94.refreshingText;
  currVal_3;
}
function _View_Scroll_Host_26_0():void {
  var _any:any = (null as any);
}
function _View_Scroll_26_0():void {
  var _any:any = (null as any);
}
function _View_Searchbar_Host_27_0():void {
  var _any:any = (null as any);
}
function _View_Searchbar_27_0():void {
  var _any:any = (null as any);
  const currVal_0:any = 'dark';
  currVal_0;
  const currVal_1:any = 'md';
  currVal_1;
  const currVal_2:any = '';
  currVal_2;
  const currVal_3:any = 'md-arrow-back';
  currVal_3;
  const currVal_4:any = _decl0_97.placeholder;
  currVal_4;
  const currVal_5:any = _decl0_97.type;
  currVal_5;
  const currVal_6:any = _decl0_97._autocomplete;
  currVal_6;
  const currVal_7:any = _decl0_97._autocorrect;
  currVal_7;
  const currVal_8:any = _decl0_97._spellcheck;
  currVal_8;
  const currVal_9:any = _decl0_97._mode;
  currVal_9;
  const currVal_10:any = '';
  currVal_10;
  const currVal_11:any = 'ios';
  currVal_11;
  const currVal_12:any = '';
  currVal_12;
  const currVal_13:any = (_decl0_97._isActive? 1: (0 - 1));
  currVal_13;
  const currVal_14:any = _decl0_97.cancelButtonText;
  currVal_14;
  const pd_15:any = ((<any>_decl0_97.cancelSearchbar(_any)) !== false);
  const pd_16:any = ((<any>_decl0_97.cancelSearchbar(_any)) !== false);
  const pd_17:any = ((<any>_decl0_97.inputChanged(_any)) !== false);
  const pd_18:any = ((<any>_decl0_97.inputBlurred()) !== false);
  const pd_19:any = ((<any>_decl0_97.inputFocused()) !== false);
  const pd_20:any = ((<any>_decl0_97.clearInput(_any)) !== false);
  const pd_21:any = ((<any>_decl0_97.clearInput(_any)) !== false);
  const pd_22:any = ((<any>_decl0_97.cancelSearchbar(_any)) !== false);
  const pd_23:any = ((<any>_decl0_97.cancelSearchbar(_any)) !== false);
}
function _View_SegmentButton_Host_28_0():void {
  var _any:any = (null as any);
}
function _View_SegmentButton_28_0():void {
  var _any:any = (null as any);
}
function _View_Select_Host_29_0():void {
  var _any:any = (null as any);
}
function _View_Select_29_0():void {
  var _any:any = (null as any);
  const currVal_0:any = !_decl0_100._text;
  currVal_0;
  const currVal_1:any = _decl0_100._text;
  currVal_1;
  const currVal_2:any = _decl0_100.id;
  currVal_2;
  const currVal_3:any = _decl0_100._labelId;
  currVal_3;
  const currVal_4:any = _decl0_100._disabled;
  currVal_4;
}
function _View_SelectPopover_Host_30_0():void {
  var _any:any = (null as any);
}
function _View_SelectPopover_30_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_101.value;
  currVal_0;
  const currVal_1:any = _decl0_101.options;
  currVal_1;
  const pd_2:any = ((<any>(_decl0_101.value = _any)) !== false);
}
function _View_Slide_Host_31_0():void {
  var _any:any = (null as any);
}
function _View_Slide_31_0():void {
  var _any:any = (null as any);
}
function _View_Slides_Host_32_0():void {
  var _any:any = (null as any);
}
function _View_Slides_32_0():void {
  var _any:any = (null as any);
  const currVal_0:any = (_decl0_105._rtl? 'rtl': null);
  currVal_0;
  const currVal_1:any = !_decl0_105.pager;
  currVal_1;
}
function _View_Spinner_Host_33_0():void {
  var _any:any = (null as any);
}
function _View_Spinner_33_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_106._c;
  currVal_0;
  const currVal_1:any = _decl0_106._l;
  currVal_1;
}
function _View_Tab_Host_34_0():void {
  var _any:any = (null as any);
}
function _View_Tab_34_0():void {
  var _any:any = (null as any);
}
function _View_TabButton_Host_35_0():void {
  var _any:any = (null as any);
}
function _View_TabButton_35_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_109.tab.tabIcon;
  currVal_0;
  const currVal_1:any = _decl0_109.tab.tabTitle;
  currVal_1;
  const currVal_2:any = _decl0_109.tab.tabBadge;
  currVal_2;
}
function _View_Tabs_Host_36_0():void {
  var _any:any = (null as any);
}
function _View_Tabs_36_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_111._tabs;
  currVal_0;
}
function _View_TextInput_Host_37_0():void {
  var _any:any = (null as any);
}
function _View_TextInput_37_0():void {
  var _any:any = (null as any);
  const currVal_0:any = !_decl0_112._isTextarea;
  currVal_0;
  const currVal_1:any = _decl0_112._isTextarea;
  currVal_1;
  const currVal_2:any = _decl0_112._clearInput;
  currVal_2;
  const currVal_3:any = _decl0_112._useAssist;
  currVal_3;
}
function _View_ToastCmp_Host_38_0():void {
  var _any:any = (null as any);
}
function _View_ToastCmp_38_0():void {
  var _any:any = (null as any);
  const currVal_0:any = (_decl0_114.d.position === 'bottom');
  currVal_0;
  const currVal_1:any = (_decl0_114.d.position === 'middle');
  currVal_1;
  const currVal_2:any = (_decl0_114.d.position === 'top');
  currVal_2;
  const currVal_3:any = _decl0_114.d.message;
  currVal_3;
  const currVal_4:any = _decl0_114.d.showCloseButton;
  currVal_4;
}
function _View_Toggle_Host_39_0():void {
  var _any:any = (null as any);
}
function _View_Toggle_39_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_115.id;
  currVal_0;
  const currVal_1:any = _decl0_115._value;
  currVal_1;
  const currVal_2:any = _decl0_115._labelId;
  currVal_2;
  const currVal_3:any = _decl0_115._disabled;
  currVal_3;
}
function _View_Toolbar_Host_40_0():void {
  var _any:any = (null as any);
}
function _View_Toolbar_40_0():void {
  var _any:any = (null as any);
  const currVal_0:any = 'toolbar-background';
  currVal_0;
  const currVal_1:any = ('toolbar-background-' + _decl0_118._mode);
  currVal_1;
  const currVal_2:any = 'toolbar-content';
  currVal_2;
  const currVal_3:any = ('toolbar-content-' + _decl0_118._mode);
  currVal_3;
}
function _View_ToolbarTitle_Host_41_0():void {
  var _any:any = (null as any);
}
function _View_ToolbarTitle_41_0():void {
  var _any:any = (null as any);
  const currVal_0:any = 'toolbar-title';
  currVal_0;
  const currVal_1:any = ('toolbar-title-' + _decl0_120._mode);
  currVal_1;
}
function _View_Navbar_Host_42_0():void {
  var _any:any = (null as any);
}
function _View_Navbar_42_0():void {
  var _any:any = (null as any);
  const currVal_0:any = 'toolbar-background';
  currVal_0;
  const currVal_1:any = ('toolbar-background-' + _decl0_121._mode);
  currVal_1;
  const currVal_2:any = 'back-button';
  currVal_2;
  const currVal_3:any = ('back-button-' + _decl0_121._mode);
  currVal_3;
  const currVal_4:any = _decl0_121._hideBb;
  currVal_4;
  const currVal_5:any = 'back-button-icon';
  currVal_5;
  const currVal_6:any = ('back-button-icon-' + _decl0_121._mode);
  currVal_6;
  const currVal_7:any = _decl0_121._bbIcon;
  currVal_7;
  const currVal_8:any = 'back-button-text';
  currVal_8;
  const currVal_9:any = ('back-button-text-' + _decl0_121._mode);
  currVal_9;
  const currVal_10:any = _decl0_121._backText;
  currVal_10;
  const currVal_11:any = 'toolbar-content';
  currVal_11;
  const currVal_12:any = ('toolbar-content-' + _decl0_121._mode);
  currVal_12;
  const pd_13:any = ((<any>_decl0_121.backButtonClick(_any)) !== false);
}
export const IonicPageModuleNgFactory:i0.NgModuleFactory<i1.IonicPageModule> = (null as any);
var _decl1_0:i2.NgClass = (<any>(null as any));
var _decl1_1:i2.NgComponentOutlet = (<any>(null as any));
var _decl1_2:i2.NgForOf<any> = (<any>(null as any));
var _decl1_3:i2.NgIf = (<any>(null as any));
var _decl1_4:i2.NgTemplateOutlet = (<any>(null as any));
var _decl1_5:i2.NgStyle = (<any>(null as any));
var _decl1_6:i2.NgSwitch = (<any>(null as any));
var _decl1_7:i2.NgSwitchCase = (<any>(null as any));
var _decl1_8:i2.NgSwitchDefault = (<any>(null as any));
var _decl1_9:i2.NgPlural = (<any>(null as any));
var _decl1_10:i2.NgPluralCase = (<any>(null as any));
var _decl1_11:i3.ɵbf = (<any>(null as any));
var _decl1_12:i3.NgSelectOption = (<any>(null as any));
var _decl1_13:i3.ɵq = (<any>(null as any));
var _decl1_14:i3.DefaultValueAccessor = (<any>(null as any));
var _decl1_15:i3.ɵbc = (<any>(null as any));
var _decl1_16:i3.ɵbe = (<any>(null as any));
var _decl1_17:i3.CheckboxControlValueAccessor = (<any>(null as any));
var _decl1_18:i3.SelectControlValueAccessor = (<any>(null as any));
var _decl1_19:i3.SelectMultipleControlValueAccessor = (<any>(null as any));
var _decl1_20:i3.RadioControlValueAccessor = (<any>(null as any));
var _decl1_21:i3.NgControlStatus = (<any>(null as any));
var _decl1_22:i3.NgControlStatusGroup = (<any>(null as any));
var _decl1_23:i3.RequiredValidator = (<any>(null as any));
var _decl1_24:i3.MinLengthValidator = (<any>(null as any));
var _decl1_25:i3.MaxLengthValidator = (<any>(null as any));
var _decl1_26:i3.PatternValidator = (<any>(null as any));
var _decl1_27:i3.CheckboxRequiredValidator = (<any>(null as any));
var _decl1_28:i3.EmailValidator = (<any>(null as any));
var _decl1_29:i3.NgModel = (<any>(null as any));
var _decl1_30:i3.NgModelGroup = (<any>(null as any));
var _decl1_31:i3.NgForm = (<any>(null as any));
var _decl1_32:i3.FormControlDirective = (<any>(null as any));
var _decl1_33:i3.FormGroupDirective = (<any>(null as any));
var _decl1_34:i3.FormControlName = (<any>(null as any));
var _decl1_35:i3.FormGroupName = (<any>(null as any));
var _decl1_36:i3.FormArrayName = (<any>(null as any));
var _decl1_37:i4.ActionSheetCmp = (<any>(null as any));
var _decl1_38:i5.AlertCmp = (<any>(null as any));
var _decl1_39:i6.ClickBlock = (<any>(null as any));
var _decl1_40:i7.IonicApp = (<any>(null as any));
var _decl1_41:i8.OverlayPortal = (<any>(null as any));
var _decl1_42:i9.Avatar = (<any>(null as any));
var _decl1_43:i10.Backdrop = (<any>(null as any));
var _decl1_44:i11.Badge = (<any>(null as any));
var _decl1_45:i12.Button = (<any>(null as any));
var _decl1_46:i13.Card = (<any>(null as any));
var _decl1_47:i14.CardContent = (<any>(null as any));
var _decl1_48:i15.CardHeader = (<any>(null as any));
var _decl1_49:i16.CardTitle = (<any>(null as any));
var _decl1_50:i17.Checkbox = (<any>(null as any));
var _decl1_51:i18.Chip = (<any>(null as any));
var _decl1_52:i19.Col = (<any>(null as any));
var _decl1_53:i20.Content = (<any>(null as any));
var _decl1_54:i21.DateTime = (<any>(null as any));
var _decl1_55:i22.FabButton = (<any>(null as any));
var _decl1_56:i23.FabContainer = (<any>(null as any));
var _decl1_57:i24.FabList = (<any>(null as any));
var _decl1_58:i25.Grid = (<any>(null as any));
var _decl1_59:i26.Img = (<any>(null as any));
var _decl1_60:i27.Icon = (<any>(null as any));
var _decl1_61:i28.InfiniteScroll = (<any>(null as any));
var _decl1_62:i29.InfiniteScrollContent = (<any>(null as any));
var _decl1_63:i30.Item = (<any>(null as any));
var _decl1_64:i31.ItemContent = (<any>(null as any));
var _decl1_65:i32.ItemDivider = (<any>(null as any));
var _decl1_66:i33.ItemGroup = (<any>(null as any));
var _decl1_67:i34.ItemOptions = (<any>(null as any));
var _decl1_68:i35.ItemReorder = (<any>(null as any));
var _decl1_69:i36.ItemSliding = (<any>(null as any));
var _decl1_70:i37.Label = (<any>(null as any));
var _decl1_71:i38.List = (<any>(null as any));
var _decl1_72:i39.ListHeader = (<any>(null as any));
var _decl1_73:i40.Reorder = (<any>(null as any));
var _decl1_74:i41.LoadingCmp = (<any>(null as any));
var _decl1_75:i42.Menu = (<any>(null as any));
var _decl1_76:i43.MenuClose = (<any>(null as any));
var _decl1_77:i44.MenuToggle = (<any>(null as any));
var _decl1_78:i45.ModalCmp = (<any>(null as any));
var _decl1_79:i46.Nav = (<any>(null as any));
var _decl1_80:i47.NavPop = (<any>(null as any));
var _decl1_81:i48.NavPopAnchor = (<any>(null as any));
var _decl1_82:i49.NavPush = (<any>(null as any));
var _decl1_83:i50.NavPushAnchor = (<any>(null as any));
var _decl1_84:i51.Note = (<any>(null as any));
var _decl1_85:i52.Option = (<any>(null as any));
var _decl1_86:i53.PickerCmp = (<any>(null as any));
var _decl1_87:i54.PickerColumnCmp = (<any>(null as any));
var _decl1_88:i55.PopoverCmp = (<any>(null as any));
var _decl1_89:i56.RadioButton = (<any>(null as any));
var _decl1_90:i57.RadioGroup = (<any>(null as any));
var _decl1_91:i58.Range = (<any>(null as any));
var _decl1_92:i59.RangeKnob = (<any>(null as any));
var _decl1_93:i60.Refresher = (<any>(null as any));
var _decl1_94:i61.RefresherContent = (<any>(null as any));
var _decl1_95:i62.Row = (<any>(null as any));
var _decl1_96:i63.Scroll = (<any>(null as any));
var _decl1_97:i64.Searchbar = (<any>(null as any));
var _decl1_98:i65.Segment = (<any>(null as any));
var _decl1_99:i66.SegmentButton = (<any>(null as any));
var _decl1_100:i67.Select = (<any>(null as any));
var _decl1_101:i68.SelectPopover = (<any>(null as any));
var _decl1_102:i69.ShowWhen = (<any>(null as any));
var _decl1_103:i70.HideWhen = (<any>(null as any));
var _decl1_104:i71.Slide = (<any>(null as any));
var _decl1_105:i72.Slides = (<any>(null as any));
var _decl1_106:i73.Spinner = (<any>(null as any));
var _decl1_107:i74.SplitPane = (<any>(null as any));
var _decl1_108:i75.Tab = (<any>(null as any));
var _decl1_109:i76.TabButton = (<any>(null as any));
var _decl1_110:i77.TabHighlight = (<any>(null as any));
var _decl1_111:i78.Tabs = (<any>(null as any));
var _decl1_112:i79.TextInput = (<any>(null as any));
var _decl1_113:i80.Thumbnail = (<any>(null as any));
var _decl1_114:i81.ToastCmp = (<any>(null as any));
var _decl1_115:i82.Toggle = (<any>(null as any));
var _decl1_116:i83.Footer = (<any>(null as any));
var _decl1_117:i84.Header = (<any>(null as any));
var _decl1_118:i85.Toolbar = (<any>(null as any));
var _decl1_119:i86.ToolbarItem = (<any>(null as any));
var _decl1_120:i87.ToolbarTitle = (<any>(null as any));
var _decl1_121:i88.Navbar = (<any>(null as any));
var _decl1_122:i89.Typography = (<any>(null as any));
var _decl1_123:i90.VirtualFooter = (<any>(null as any));
var _decl1_124:i91.VirtualHeader = (<any>(null as any));
var _decl1_125:i92.VirtualItem = (<any>(null as any));
var _decl1_126:i93.VirtualScroll = (<any>(null as any));
var _decl1_127:i2.AsyncPipe = (<any>(null as any));
var _decl1_128:i2.UpperCasePipe = (<any>(null as any));
var _decl1_129:i2.LowerCasePipe = (<any>(null as any));
var _decl1_130:i2.JsonPipe = (<any>(null as any));
var _decl1_131:i2.SlicePipe = (<any>(null as any));
var _decl1_132:i2.DecimalPipe = (<any>(null as any));
var _decl1_133:i2.PercentPipe = (<any>(null as any));
var _decl1_134:i2.TitleCasePipe = (<any>(null as any));
var _decl1_135:i2.CurrencyPipe = (<any>(null as any));
var _decl1_136:i2.DatePipe = (<any>(null as any));
var _decl1_137:i2.I18nPluralPipe = (<any>(null as any));
var _decl1_138:i2.I18nSelectPipe = (<any>(null as any));
var _decl1_140:i1.IonicModule = (<any>(null as any));
var _decl1_141:i0.TemplateRef<any> = (<any>(null as any));
var _decl1_142:i0.ElementRef = (<any>(null as any));
